import http from '../../utils/Http/Http'

export type UserMetricsResponse = {
	total_leads: string
	total_campaigns: string
	total_calls: string
	total_answered_calls: string
	total_callback_requests: string
}

export default async function getUserMetrics(startDate?: string): Promise<UserMetricsResponse> {
	const response = await http({
		method: 'get',
		url: '/user/metrics',
		params: {
			from_date: startDate,
		},
	})
	return response.data
}
